module.exports = "https://www.gc-pro.gnp.com.mx/cf9c0ccfa7d22ff3c19f20b39f9edeb0.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/clear_x.svg
// module id = 1808
// module chunks = 0